import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { MuiThemeProvider } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
import { saveTenantLocalStorage } from 'api/tenant';
import Router from './router';
import store, { persistor } from './store';
import theme from './theme';

function getCurrentTenant(host) {
  const tenants = {
    umc: 'umc',
    upf: 'upf',
    utp: 'utp',
    haoc: 'haoc',
    infoprod: 'infoprod',
    kroton: 'kroton',
    mackenzie: 'mackenzie',
  };

  if (!host) return 'kroton';

  const subdomain = host.split('.')[0];
  return tenants[subdomain] || 'kroton';
}

function App() {
  useEffect(() => {
    saveTenantLocalStorage(getCurrentTenant(window.location.host));
  }, []);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <MuiThemeProvider theme={theme}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <Router />
          </SnackbarProvider>
        </MuiThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
